import styled from "styled-components";
import { withNamespaces } from "react-i18next";
import { Link } from "react-router-dom";

const ItemContainer = styled.ul`
  width: 40%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
`;
const ListItem = styled.li`
  margin: 0 0.5rem;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.font.Xsmall};
  font-weight: 400;
  text-decoration: none;
  @media (max-width: 768px) {
    margin: 1rem 0;
    width: 100%;
    border-bottom: 1px solid #e4e4e4;
    padding: 0 0 1rem 0;
  }
`;
const ItemLink = styled(Link)`
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.font.small};
  font-weight: 500;
  text-decoration: none;
  @media (max-width: 768px) {
    color: #1b292c;
  }
`;

const NavItems = ({ t, direction }) => {
  return (
    <>
      <ItemContainer direction={direction}>
        <ListItem>
          <ItemLink smooth={true} to="home">
            {t("navbar.links.home")}
          </ItemLink>
        </ListItem>
        <ListItem>
          <ItemLink smooth={true} to="services">
            {t("navbar.links.services")}
          </ItemLink>
        </ListItem>
        <ListItem>
          <ItemLink smooth={true} to="why-totarjim">
            {t("navbar.links.whyTotarjim")}
          </ItemLink>
        </ListItem>
        <ListItem>
          <ItemLink smooth={true} to="footer">
            {t("navbar.links.contactUs")}
          </ItemLink>
        </ListItem>
      </ItemContainer>
    </>
  );
};

export default withNamespaces()(NavItems);
